<template>
  <v-dialog max-width="1000px" persistent v-model="dialog">
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto" v-if="close_cropper == true">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center>
            <v-flex xs12 sm6 class="pr-2">
              <v-card
                flat
                color="grey lighten-3"
                v-if="form.banner_promotion_image == null"
              >
                <v-responsive :aspect-ratio="2.3333333333333">
                  <v-tooltip top>
                    <v-btn
                      fab
                      small
                      @click="$refs.ImageInput.click()"
                      depressed
                      class="add-btn elevation-5"
                      slot="activator"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    <input
                      style="display: none"
                      type="file"
                      @change="onBannerSelected"
                      ref="ImageInput"
                      accept="image/*"
                    />
                    <span>Add image</span>
                  </v-tooltip>
                </v-responsive>
              </v-card>
              <div
                class="btn-container"
                v-if="
                  form.banner_promotion_image &&
                    form.banner_promotion_image != null
                "
              >
                <img
                  :src="form.banner_promotion_image"
                  width="100%"
                  style="max-height: 225px"
                />
                <!-- <v-img
                :src="form.banner_promotion_image"
                :aspect-ratio="2.3"
                v-if="form.banner_promotion_image && form.banner_promotion_image != null"
                contain
                >-->
                <v-tooltip top class="edit-img">
                  <v-btn
                    @click="$refs.ImageInput.click()"
                    fab
                    small
                    depressed
                    class="add-btn elevation-5"
                    slot="activator"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <input
                    style="display: none"
                    type="file"
                    @change="onBannerSelected"
                    ref="ImageInput"
                    accept="image/*"
                  />
                  <span>Edit image</span>
                </v-tooltip>
                <!-- </v-img> -->
              </div>
            </v-flex>
            <v-flex
              xs12
              sm6
              class="pl-2"
              style="overflow: scroll; min-height: 310px; max-height: 500px"
            >
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.banner_promotion_name"
                    label="Banner name"
                    color="black"
                    hide-details
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pr-2">
                  <v-text-field
                    v-model="form.banner_promotion_code"
                    label="Promotion code"
                    color="black"
                    hide-details
                    mask="NNNNNNNN"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pl-2">
                  <v-select
                    @change="changeType()"
                    v-model="form.banner_promotion_type"
                    :items="items"
                    label="Type"
                    item-text="name"
                    item-value="value"
                    color="black"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>

                <v-radio-group
                  v-if="form.banner_promotion_type != 6"
                  v-model="selectStoreType"
                  @change="selectType()"
                  :mandatory="false"
                  row
                  hide-details
                >
                  <v-radio
                    label="All store"
                    color="black"
                    :value="0"
                    class="mt-2"
                  ></v-radio>
                  <v-radio
                    label="Select store"
                    color="black"
                    :value="1"
                    class="mt-2"
                  ></v-radio>
                  <v-radio
                    label="Partner store"
                    color="black"
                    :value="2"
                    class="mt-2"
                  ></v-radio>
                  <v-radio
                    label="No partner store"
                    color="black"
                    :value="3"
                    class="mt-2"
                  ></v-radio>
                </v-radio-group>
                <v-radio-group
                  @change="selectType()"
                  v-else
                  v-model="selectStoreDinein"
                  :mandatory="false"
                  row
                  hide-details
                >
                  <v-radio
                    label="All store"
                    color="black"
                    :value="0"
                    class="mt-2"
                  ></v-radio>
                  <v-radio
                    label="Select store"
                    color="black"
                    :value="1"
                    class="mt-2"
                  ></v-radio>
                </v-radio-group>
                <v-flex xs12>
                  <v-card
                    v-if="selectStoreDinein == 1"
                    flat
                    style="background-color: #F8F8F8;border-radius: 7px;"
                    class="my-3 pa-2"
                  >
                    <div style="display: flex; align-items: center">
                      <v-text-field
                        prepend-icon="search"
                        style="width: 300px"
                        label="Search store name"
                        v-model="search"
                      ></v-text-field>
                      <v-btn
                        @click="form.banner_promotion_store = [{ store_id: 0 }]"
                        >CLEAR</v-btn
                      >
                    </div>
                    <v-layout
                      row
                      wrap
                      v-for="(info, index) in searchStore.slice(0, 10)"
                      :key="index"
                    >
                      <v-flex xs10>
                        <v-autocomplete
                          :loading="isLoadingStore"
                          label="Store name"
                          item-text="store_name_th"
                          return-object
                          :value="info"
                          @change="selectAStore($event, info)"
                          :items="autocompleteStoreDinein"
                          color="black"
                          :rules="[rules.requiredStore, rules.alreadyStore]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex
                        xs2
                        style="cursor: pointer"
                        class="text-xs-center pt-3"
                        v-if="findStoreIndex(info) == 0"
                        @click="moreStore()"
                      >
                        <v-icon large color="green">add_box</v-icon>
                      </v-flex>
                      <v-flex
                        xs2
                        class="text-xs-center pt-3"
                        style="cursor: pointer"
                        v-else-if="findStoreIndex(info) > 0"
                        @click="
                          form.banner_promotion_store.splice(
                            findStoreIndex(info),
                            1
                          )
                        "
                      >
                        <v-icon large color="red"
                          >indeterminate_check_box</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <div class="text-xs-center">
                      Total store: {{ form.banner_promotion_store.length }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="pl-4">
                  <v-card
                    flat
                    class="my-3 pa-2"
                  >
                  <section v-if="selectStoreType == 1">
                    <div style="display: flex; align-items: center">
                      <v-text-field
                        prepend-icon="search"
                        style="width: 300px"
                        label="Search store name"
                        v-model="search"
                      ></v-text-field>
                      <v-btn
                        @click="form.banner_promotion_store = [{ store_id: 0 }]"
                        >CLEAR</v-btn
                      >
                    </div>
                    <v-layout
                      row
                      wrap
                      v-for="(info, index) in searchStore.slice(0, 10)"
                      :key="index"
                    >
                      <v-flex xs10>
                        <v-autocomplete
                          :loading="isLoadingStore"
                          label="Store name"
                          item-text="store_name_th"
                          return-object
                          :value="info"
                          @change="selectAStore($event, info)"
                          :items="autocompleteStore"
                          color="black"
                          :rules="[rules.requiredStore, rules.alreadyStore]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex
                        xs2
                        style="cursor: pointer"
                        class="text-xs-center pt-3"
                        v-if="findStoreIndex(info) == 0"
                        @click="moreStore()"
                      >
                        <v-icon large color="green">add_box</v-icon>
                      </v-flex>
                      <v-flex
                        xs2
                        class="text-xs-center pt-3"
                        style="cursor: pointer"
                        v-else-if="findStoreIndex(info) > 0"
                        @click="
                          form.banner_promotion_store.splice(
                            findStoreIndex(info),
                            1
                          )
                        "
                      >
                        <v-icon large color="red"
                          >indeterminate_check_box</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <div class="text-xs-center">
                      Total store: {{ form.banner_promotion_store.length }}
                    </div>
                  </section>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-textarea
                v-model="form.banner_promotion_note"
                name="input-7-1"
                label="Description"
                rows="2"
                color="black"
                hide-details
              ></v-textarea>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu_start"
                    :nudge-right="-30"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <v-text-field
                      color="black"
                      slot="activator"
                      v-model="form.banner_promotion_date_start"
                      label="Start date"
                      prepend-icon="event"
                      hide-details
                      readonly
                      :rules="[rules.required]"
                    ></v-text-field>

                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="#333"
                      no-title
                      v-model="form.banner_promotion_date_start"
                      @input="menu_start = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu_end"
                    :nudge-right="-30"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <v-text-field
                      color="black"
                      slot="activator"
                      v-model="form.banner_promotion_date_end"
                      label="End date"
                      prepend-icon="event"
                      hide-details
                      readonly
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="#333"
                      no-title
                      v-model="form.banner_promotion_date_end"
                      @input="menu_end = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-text v-if="!close_cropper">
        <imageCropper
          :aspectRatio="21 / 9"
          :imageName="image_name"
          :imgSrc="imgSrc"
          :height="300"
          @close="close_cropper = true"
          @setImageName="image_name = $event"
          @getCroped="getCropped($event)"
          v-if="imgSrc != ''"
        ></imageCropper>
      </v-card-text>
      <v-divider v-if="close_cropper" />
      <v-card-actions v-if="close_cropper">
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancel()" :disabled="posting_data"
          >Cancel</v-btn
        >
        <v-btn
          color="green"
          flat
          @click="save()"
          :disabled="posting_data"
          :loading="posting_data"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import imageCropper from "@/components/Plugins/imageCropper";
export default {
  components: {
    imageCropper,
  },
  props: ["dialog", "editedIndex", "form", "isLoadingStore"],
  data: () => ({
    store_search: "",

    selectStoreType: 0,
    posting_data: false,
    change_image: 0,
    close_cropper: true,
    imgSrc: "",
    image_name: "",
    items: [
      { name: "Food delivery", value: 1 },
      { name: "Free delivery", value: 3 },
      { name: "Messenger", value: 2 },
      { name: "Dine In", value: 6 },
    ],
    date: new Date().toISOString().substr(0, 10),
    menu_start: false,
    menu_end: false,
    imgURL: null,
    valid: true,
    rules: {
      required: (value) => !!value || "Required.",
      requiredStore: (value) => (!!value && value.store_id != 0) || "Required.",
      alreadyStore: (value) =>
        value.store_id != -1 || "Store already to select.",
    },
    search: "",
    selectStoreDinein: 0,
  }),
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.change_image = 0;
        this.selectStoreType = 0;
        if (this.editedIndex == -1) {
          this.$emit("setForm");
          this.$refs.form.resetValidation();
        } else {
          if (
            this.form.banner_promotion_store[0] &&
            this.form.banner_promotion_store[0] != 0
          ) {
            this.selectStoreType = 1;
          }
        }
        if (this.formTitle == "Edit banner" && this.form.banner_promotion_type == 6) {
          this.selectStoreType = 0;
          if(this.searchStore.length == 0) {
            this.selectStoreDinein = 0
          }else{
            this.selectStoreDinein = 1
          } 
        }
      }else {
        this.selectStoreType = 0;
        this.selectStoreDinein = 0;
      }
    },
  },
  computed: {
    ...mapState({
      promotion_banner: (state) =>
        state.fetchFoodPromotionBack.promotion_banner,
        store_list: (state) =>
        state.fetchDineIn.store_list,
    }),
    ...mapGetters({
      autocompleteStore: "fetchStoreBack/autocompleteStore",
      autocompleteStoreDinein: 'fetchDineIn/autocompleteStoreDinein'
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New banner" : "Edit banner";
    },
    searchStore() {
      let storeList = [];
      if (this.search == "") {
        storeList = this.form.banner_promotion_store;
      } else {
        storeList = this.form.banner_promotion_store.filter((val) => {
          if (val.store_id == 0 || val.store_id == -1) {
            return true;
          } else {
            return val.store_name_th.includes(this.search);
          }
        });
      }
      return storeList;
    },
  },
  methods: {
    selectAStore(value, info) {
      if (value == undefined) {
        this.form.banner_promotion_store.splice(this.findStoreIndex(info), 1, {
          store_id: 0,
        });
        return;
      }
      if (
        !this.form.banner_promotion_store.some(
          (val) => val.store_id == value.store_id
        )
      ) {
        this.form.banner_promotion_store.splice(
          this.findStoreIndex(info),
          1,
          value
        );
      } else {
        this.form.banner_promotion_store.splice(this.findStoreIndex(info), 1, {
          store_id: -1,
        });
      }
    },
    moreStore() {
      if (
        this.form.banner_promotion_store.length > 0 &&
        (this.form.banner_promotion_store[0].store_id == 0 ||
          this.form.banner_promotion_store[0].store_id == -1)
      )
        return;
      this.form.banner_promotion_store.unshift({ store_id: 0 });
    },
    selectType() {
      if (this.selectStoreType == 1) {
        this.form.banner_promotion_store = [];
        this.form.banner_promotion_store.push({ store_id: 0 });
      }
      if(this.selectStoreDinein==1 && this.searchStore.length == 0){
        this.form.banner_promotion_store.push({ store_id: 0 });
      }
      
    },
    changeType(){
        this.selectStoreType = 0
        this.selectStoreDinein = 0
        this.form.banner_promotion_store = [];
    },
    findStoreIndex(info) {
      return this.form.banner_promotion_store.findIndex((val) => {
        return val.store_id == info.store_id;
      });
    },
    includePartner() {
      let arr = this.autocompleteStore.filter(
        (val) => val.store_partner == true
      );
      return arr;
    },
    includeNoPartner() {
      let arr = this.autocompleteStore.filter(
        (val) => val.store_partner == false
      );
      return arr;
    },
    cancel() {
      this.close_cropper = true;
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
      this.$emit("cancel");
    },
    getCropped(image_value) {
      this.form.banner_promotion_image = image_value;
      this.close_cropper = true;
      this.image_name = "";
      this.change_image = 1;
    },
    onBannerSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        if (file.type == "image/gif") {
          this.getCropped(reader.result);
        } else {
          this.imgSrc = reader.result;
          this.close_cropper = false;
        }
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.form.banner_promotion_status = 0;
        let index = this.promotion_banner.indexOf(this.form);
        let clone_obj = JSON.parse(JSON.stringify(this.form));
        for (let x in clone_obj) {
          let arr_split = x.split("_");
          if (arr_split[arr_split.length - 1] == "temp") {
            delete clone_obj[x];
          }
        }
        if (this.change_image == 0) {
          delete clone_obj.banner_promotion_image;
        }
        if (this.selectStoreType == 0 && this.selectStoreDinein == 0) {
          clone_obj.banner_promotion_store = [0];
        } else if (this.selectStoreType == 2) {
          clone_obj.banner_promotion_store = await this.includePartner();
        } else if (this.selectStoreType == 3) {
          clone_obj.banner_promotion_store = await this.includeNoPartner();
        }
        if (this.selectStoreType != 0 || this.selectStoreDinein == 1) {
          clone_obj.banner_promotion_store = clone_obj.banner_promotion_store.map(
            (val) => val.store_id
          );
        }
        if (clone_obj.banner_promotion_code == "") {
          clone_obj.banner_promotion_code = null;
        }
        this.posting_data = true;
        let check = true;
        if (this.editedIndex == -1) {
          check = await this.$store.dispatch(
            "fetchFoodPromotionBack/addPromotionBanner",
            clone_obj
          );
        } else {
          check = await this.$store.dispatch(
            "fetchFoodPromotionBack/editPromotionBanner",
            { form: clone_obj, index }
          );
        }
        if (check == true) {
          this.$emit("setDialog", false);
          this.$emit("setEditIndex", -1);
        }
        this.posting_data = false;
      }
    },
  },
};
</script>

<style scoped>
.add-btn {
  top: 42%;
  left: 42%;
}
.v-input--selection-controls {
  margin-top: 0px;
}
/* สัดส่วนรูป21/9 */
.btn-container {
  position: relative;
}

.btn-container .edit-img {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 46%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
